import {
  Morgan,
  Navistar,
  Nevs,
  Nikola,
  Nio,
  Nismo,
  Nissan,
  Noble,
  Oldsmobile,
} from "../assets/images";

export const brands = [
  Nissan,
  Morgan,
  Noble,
  Oldsmobile,
  Nio,
  Nikola,
  Navistar,
  Nismo,
  Nevs,
];
